import { render } from "./CustomerIdentifierQrModal.vue?vue&type=template&id=b42011a8"
import script from "./CustomerIdentifierQrModal.vue?vue&type=script&lang=js"
export * from "./CustomerIdentifierQrModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__